// @flow
import env from '../../../environment';
import {getCreator, postCreator, putCreator} from '../../../http';

export type TaxRequest = {
  productCategories?: string[],
  includedProducts?: string[],
  excludedProducts?: string[],
  taxTypeId: string,
};

// IGV ISC
export const taxesInfoValues = [
  {label: 'IGV', name: 'IGV Impuesto General a las Ventas', value: '18'},
  // {label: 'IVAP', name: 'Impuesto a la Venta Arroz Pilado', value: '4'},
  {label: 'ISC', name: 'ISC Impuesto Selectivo al Consumo'},
  // {label: 'IR', name: 'Impuesto a la Renta'},
  // {label: 'ICBPER', name: 'Impuesto a la bolsa plastica'},
  // {label: 'EXP', name: 'Exportación'},
  // {label: 'GRA', name: 'Gratuito'},
  {label: 'EXO', name: 'Exonerado', value: '0'},
  // {label: 'INA', name: 'Inafecto'},
  // {label: 'OTROS', name: 'Otros tributos'},
];

export const endpoints = Object.freeze({
  GET_TAXES: `${env.baseApiUrl}/im/admin/tax`,
  GET_TAX: `${env.baseApiUrl}/im/admin/tax/:taxId`,
  GET_PRODUCT_TAXES: `${env.baseApiUrl}/im/tax/product/:productId`,
  GET_TAX_SETTING: `${env.baseApiUrl}/im/admin/tax/setting`,
  GET_TAX_TYPES: `${env.baseApiUrl}/im/admin/tax/type`,
});

export const getTaxesApi = getCreator(endpoints.GET_TAXES);
export const getTaxApi = getCreator(endpoints.GET_TAX);
export const createTaxApi = postCreator(endpoints.GET_TAXES);
export const updateTaxApi = putCreator(endpoints.GET_TAX);

export const getProductTaxesApi = getCreator(endpoints.GET_PRODUCT_TAXES);

export const getTaxTypesApi = getCreator(endpoints.GET_TAX_TYPES);

export const geTaxSettingApi = getCreator(endpoints.GET_TAX_SETTING);
